module.exports = __webpack_public_path__ + "static/media/venn_diagram_v2.d5e62d6e.webp";